import * as React from 'react'
import * as domain from '@packages/domain'
import { styled } from 'styled-components'
import { pipe, RA } from '@packages/prelude'
import { Image } from '../Image'

const Container = styled.div`
  width: calc(100% - 20px - 2.5rem);
`

const Title = styled.h4`
  width: 100%;
  text-transform: uppercase;
  margin-bottom: 1rem;
`

const Options = styled.div`
  position: relative;

  display: flex;
  align-items: center;
  gap: 1rem;

  width: 100%;
  overflow: hidden;

  &::after {
    content: '';
    width: 6rem;
    height: 100%;

    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;

    background: linear-gradient(to right, transparent, var(--bs-white));
  }
`

const CircularImage = styled(Image)`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;

  @media screen and (min-width: 768px) {
    width: 48px;
    height: 48px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

interface TitleWithOptionsProps {
  step: domain.Step.Type
}

export const TitleWithOptions: React.FC<TitleWithOptionsProps> = ({ step }) => (
  <Container>
    <Title>{step.title}</Title>
    <Options>
      {pipe(
        step.options,
        RA.mapWithIndex((index, option) => (
          <CircularImage key={index} imageId={option.image} alt={option.name} size="thumbnail" />
        ))
      )}
    </Options>
  </Container>
)
